export default "__VITE_ASSET__CGOt7OXw__"